import { collection, query, where, getDocs, doc, getDoc, orderBy } from 'firebase/firestore'
import firebase from '../../firebase'

const getKneeSleevePreorders = () => {
  const getPreordersByEmail = async (email) => {
    const preorders = []
    const collectionRef = collection(firebase.db, 'kneeSleevePreorders')
    const q = query(collectionRef, where('email', '==', email), orderBy('orderDate', 'desc'))
    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      preorders.push({
        ...doc.data(),
        id: doc.id
      })
    })

    return preorders
  }

  const getPreOrderById = async (docId) => {
    const docRef = doc(firebase.db, 'kneeSleevePreorders', docId)
    const docSnap = await getDoc(docRef)
    return {
      id: docSnap.id,
      ...docSnap.data()
    }
  }

  return { getPreordersByEmail, getPreOrderById }
}
export default getKneeSleevePreorders
